import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu-arrow",
  "use": "menu-arrow-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 9\" id=\"menu-arrow\">\n  <path id=\"menu-arrow_Polygon_2\" data-name=\"Polygon 2\" d=\"M4.647,1.4a1,1,0,0,1,1.707,0L10.07,7.479A1,1,0,0,1,9.217,9H1.783A1,1,0,0,1,.93,7.479Z\" transform=\"translate(11 9) rotate(180)\" fill=\"#342f41\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol